/**
 * Global search service — hits GET /api/search/?q=... and returns
 * mixed results across clients, cases, sessions, documents, messages.
 *
 * The backend respects workspace switching when `owner_account_id` is
 * passed; the topbar SearchBar always passes it when active.
 */

import apiService from './api'

export const searchAPI = {
  /**
   * Run a global search across the current workspace.
   *
   * @param {string} query - the search query (trimmed)
   * @param {object} options
   * @param {string[]} options.types - filter to these types only ('clients', 'cases', 'sessions', 'documents', 'messages')
   * @param {number} options.limit - per-type result cap (default 5)
   * @param {number|null} options.ownerAccountId - workspace context
   * @param {AbortSignal} options.signal - cancellation
   */
  async search(query, { types, limit, ownerAccountId, signal } = {}) {
    const params = { q: query }
    if (types && types.length) params.types = types.join(',')
    if (limit) params.limit = String(limit)
    if (ownerAccountId) params.owner_account_id = String(ownerAccountId)

    return apiService.get('/search/', { params, signal })
  },
}

export default searchAPI
